import { InjectionToken } from '@angular/core';
export const LOTTIE_OPTIONS = new InjectionToken('LottieOptions');
//# sourceMappingURL=symbols.js.map